import React from 'react'
import { Tooltip } from 'antd'
import { Icons } from '../../Shared/Icons'
import s from './styles.module.scss'

/**
 * Displays a sparkle icon with tooltip next to AI-generated comments.
 */

interface SparkleIndicatorProps {
  aiGenerated: boolean
}

const SparkleIndicator: React.FC<SparkleIndicatorProps> = ({ aiGenerated }) => {
  if (!aiGenerated) {
    return null
  }

  return (
    <Tooltip title="AI-generated message" mouseEnterDelay={0.3}>
      <span className={s.sparkle} data-test="ai-sparkle-indicator">
        <Icons.Sparkle />
      </span>
    </Tooltip>
  )
}

export default SparkleIndicator
